import { Col, Row, Spinner2 } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChurnShell from './ChurnShell';

const PERIODS = ['30d', '90d', '1y', 'all'];

const Churn = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('30d');
  const [viewMode, setViewMode] = useState('country');

  useEffect(() => {
    fetchChurn(period);
  }, [period]);

  async function fetchChurn(selectedPeriod) {
    setLoading(true);
    const res = await Api.get(
      `/admin/subscriptionPlans/overviewChurn?period=${selectedPeriod}`
    );
    if (res?.data) {
      setData(res.data);
    }
    setLoading(false);
  }

  if (loading) {
    return (
      <Col wid="100%" marg="80px 0" centerAll noFlex>
        <Spinner2 />
      </Col>
    );
  }

  return (
    <Col start noFlex wid="100%">
      <Row start gap="12px" pad="12px 24px" noFlex>
        {/* Period filter */}
        <div className="inline-flex items-center rounded-lg border border-[#D7DEE8] bg-[#F1F5F9] p-1">
          {PERIODS.map((p) => (
            <button
              key={p}
              type="button"
              onClick={() => setPeriod(p)}
              aria-pressed={period === p}
              className={`px-3 py-1.5 rounded-md text-[12px] font-semibold transition-all duration-150 ${
                period === p
                  ? 'bg-[#334155] text-white shadow-[0_2px_6px_rgba(15,23,42,0.28)]'
                  : 'text-[#64748B] hover:text-[#334155] hover:bg-white/70'
              }`}
            >
              {t(`subscriptions.admin.overview.churn.periods.${p}`)}
            </button>
          ))}
        </div>

        {/* Breakdown view toggle — hidden when period is all */}
        {period !== 'all' && (
          <div className="inline-flex items-center rounded-lg border border-[#D7DEE8] bg-[#F1F5F9] p-1">
            {[
              { key: 'country', label: t('subscriptions.admin.overview.churn.byCountry') },
              { key: 'plan', label: t('subscriptions.admin.overview.churn.byPlan') },
              { key: 'team', label: t('subscriptions.admin.overview.churn.byTeam') }
            ].map(({ key, label }) => (
              <button
                key={key}
                type="button"
                onClick={() => setViewMode(key)}
                aria-pressed={viewMode === key}
                className={`px-3 py-1.5 rounded-md text-[12px] font-semibold transition-all duration-150 ${
                  viewMode === key
                    ? 'bg-[#334155] text-white shadow-[0_2px_6px_rgba(15,23,42,0.28)]'
                    : 'text-[#64748B] hover:text-[#334155] hover:bg-white/70'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        )}
      </Row>

      <Col
        start
        wid="100%"
        style={{ overflow: 'auto', maxHeight: 'calc(100vh - 170px)' }}
      >
        <ChurnShell data={data} viewMode={viewMode} />
      </Col>
    </Col>
  );
};

export default Churn;
